import React, { createContext, useEffect, useState } from 'react';
import generateThemeConfig from '../themeconfig';
import { COLOR_THEME } from '../utils/constants';

export const ThemeContext = createContext({
  themeColor: '#1890FF',
  themeConfig: generateThemeConfig('#1890FF'),
  changeTheme: () => {},
  changeBackgroundTheme: () => {},
  mainTheme: 'light',
});

export const ThemeProvider = ({ children }) => {
  const [themeColor, setThemeColor] = useState(localStorage.getItem(COLOR_THEME) || '#1890FF');
  const [mainTheme, setMainTheme] = useState(localStorage.getItem('mainTheme') || 'light');

  const [themeConfig, setThemeConfig] = useState(generateThemeConfig(themeColor));
  const changeTheme = (newColor) => {
    if (newColor === 'light' || newColor === 'dark') {
      newColor = '#1890FF';
    }
    localStorage.setItem(COLOR_THEME, newColor);
    document.documentElement.style.setProperty('--primary-color', newColor);
    setThemeColor(newColor);
    setThemeConfig(generateThemeConfig({ newColor }));
  };
  const changeBackgroundTheme = (isdarkMode) => {
    if (isdarkMode) {
      setThemeConfig(generateThemeConfig({ isdarkMode }));
      document.documentElement.style.setProperty('--sidemenu-background-color', '#1D1D1D');
      document.documentElement.style.setProperty('--box-background-color', '#191919');
      document.documentElement.style.setProperty('--editor-heading-font-color', '#ffffffde');
      document.documentElement.style.setProperty('--editor-text-font-color', '#B0B0B0');
      document.documentElement.style.setProperty('--primary-header-title-color', '#3A3F44');
      document.documentElement.style.setProperty('--editor-border-color', 'rgba(255, 255, 255, 0.81)');
      document.documentElement.style.setProperty('--toolbar-wrapper-color', '#000000');
      document.documentElement.style.setProperty('--toolbar-button-color', '#F0F0F0');
      document.documentElement.style.setProperty('--collapse-button-color', '#808080');
      document.documentElement.style.setProperty('--toolbar-button-hover', '#444444');
      document.documentElement.style.setProperty('--editor-placeholder-color', '#ffffff');
      document.documentElement.style.setProperty('--tertiary-font-color', '#333333');
      document.documentElement.style.setProperty('--border-color', '#444444');
      document.documentElement.style.setProperty('--endpoint-bg-color', '#2c2f33');
      document.documentElement.style.setProperty('--parameter-bg-color', '#23272a');
      document.documentElement.style.setProperty('--param-border-color', '#555555');
      document.documentElement.style.setProperty('--placeholder-color', '#bbbbbb');
      document.documentElement.style.setProperty('--green', 'rgb(5, 150, 105)'); // Bright green
      document.documentElement.style.setProperty('--orange', '#ffa500'); // Bright orange
      document.documentElement.style.setProperty('--red', '#ff4d4d'); // Vivid red
      document.documentElement.style.setProperty('--purple', '#9b59b6'); // Muted purple
      document.documentElement.style.setProperty('--gray', '#888888'); // Light gray
      document.documentElement.style.setProperty('--code-bg', '#2b2a2a');
      document.documentElement.style.setProperty('--drawer-bg', '#1f1f1f');
      document.documentElement.style.setProperty('--search-input-bg', '#23272a');

      setMainTheme('dark');
      localStorage.setItem('mainTheme', 'dark');
    } else {
      setThemeConfig(generateThemeConfig({ isdarkMode }));
      document.documentElement.style.setProperty('--sidemenu-background-color', '#f1f5f9');
      document.documentElement.style.setProperty('--box-background-color', '#fafafa');
      document.documentElement.style.setProperty('--editor-heading-font-color', '#252103');
      document.documentElement.style.setProperty('--editor-text-font-color', '#333333');
      document.documentElement.style.setProperty('--primary-header-title-color', '#E3E8ED');
      document.documentElement.style.setProperty('--toolbar-wrapper-color', '#ffffff');
      document.documentElement.style.setProperty('--editor-border-color', 'rgba(5, 5, 5, 0.06)');
      document.documentElement.style.setProperty('--toolbar-button-color', '#616161');
      document.documentElement.style.setProperty('--collapse-button-color', 'rgb(240,240,240)');
      document.documentElement.style.setProperty('--toolbar-button-hover', 'rgba(0, 0, 0, 0.05)');
      document.documentElement.style.setProperty('--editor-placeholder-color', '#000000');
      document.documentElement.style.setProperty('--tertiary-font-color', '#efefef');
      document.documentElement.style.setProperty('--border-color', '#f0f0f0');
      document.documentElement.style.setProperty('--endpoint-bg-color', '#f5f7fa');
      document.documentElement.style.setProperty('--parameter-bg-color', '#f9f9f9');
      document.documentElement.style.setProperty('--param-border-color', '#d9d9d9');
      document.documentElement.style.setProperty('--placeholder-color', '#888');
      document.documentElement.style.setProperty('--green', 'rgb(16, 185, 129)');
      document.documentElement.style.setProperty('--orange', '#fa8c16');
      document.documentElement.style.setProperty('--red', '#f5222d');
      document.documentElement.style.setProperty('--purple', '#722ed1');
      document.documentElement.style.setProperty('--gray', '#8c8c8c');
      document.documentElement.style.setProperty('--code-bg', '#f5f5f5');
      document.documentElement.style.setProperty('--drawer-bg', '#ffff');
      document.documentElement.style.setProperty('--search-input-bg', '#E6F4FF');

      setMainTheme('light');
      localStorage.setItem('mainTheme', 'light');
    }
  };

  useEffect(() => {
    setThemeConfig(generateThemeConfig({ themeColor }));
    document.documentElement.style.setProperty('--primary-color', themeColor);
    const isdarkMode = mainTheme === 'dark';
    if (isdarkMode) {
      setThemeConfig(generateThemeConfig({ isdarkMode }));
      document.documentElement.style.setProperty('--sidemenu-background-color', '#1D1D1D');
      document.documentElement.style.setProperty('--box-background-color', '#191919');
      document.documentElement.style.setProperty('--editor-heading-font-color', '#ffffffde');
      document.documentElement.style.setProperty('--editor-text-font-color', '#B0B0B0');
      document.documentElement.style.setProperty('--primary-header-title-color', '#3A3F44');
      document.documentElement.style.setProperty('--editor-border-color', 'rgba(255, 255, 255, 0.81)');
      document.documentElement.style.setProperty('--toolbar-wrapper-color', '#000000');
      document.documentElement.style.setProperty('--toolbar-button-color', '#F0F0F0');
      document.documentElement.style.setProperty('--collapse-button-color', '#808080');
      document.documentElement.style.setProperty('--toolbar-button-hover', '#444444');
      document.documentElement.style.setProperty('--editor-placeholder-color', '#ffffff');
      document.documentElement.style.setProperty('--tertiary-font-color', '#333333');
      document.documentElement.style.setProperty('--tag-onsurface-background-color', '#444444');
      document.documentElement.style.setProperty('--border-color', '#444444');
      document.documentElement.style.setProperty('--endpoint-bg-color', '#2c2f33');
      document.documentElement.style.setProperty('--parameter-bg-color', '#23272a');
      document.documentElement.style.setProperty('--param-border-color', '#555555');
      document.documentElement.style.setProperty('--placeholder-color', '#bbbbbb');
      document.documentElement.style.setProperty('--green', 'rgb(5, 150, 105)'); // Bright green
      document.documentElement.style.setProperty('--orange', '#ffa500'); // Bright orange
      document.documentElement.style.setProperty('--red', '#ff4d4d'); // Vivid red
      document.documentElement.style.setProperty('--purple', '#9b59b6'); // Muted purple
      document.documentElement.style.setProperty('--gray', '#888888'); // Light gray
      document.documentElement.style.setProperty('--code-bg', '#2b2a2a');
      document.documentElement.style.setProperty('--drawer-bg', '#1f1f1f');
      document.documentElement.style.setProperty('--search-input-bg', '#23272a');
    } else {
      setThemeConfig(generateThemeConfig({ isdarkMode }));
      document.documentElement.style.setProperty('--sidemenu-background-color', '#f1f5f9');
      document.documentElement.style.setProperty('--box-background-color', '#fafafa');
      document.documentElement.style.setProperty('--editor-heading-font-color', '#252103');
      document.documentElement.style.setProperty('--editor-text-font-color', '#333333');
      document.documentElement.style.setProperty('--primary-header-title-color', '#E3E8ED');
      document.documentElement.style.setProperty('--toolbar-wrapper-color', '#ffffff');
      document.documentElement.style.setProperty('--editor-border-color', 'rgba(5, 5, 5, 0.06)');
      document.documentElement.style.setProperty('--toolbar-button-color', '#616161');
      document.documentElement.style.setProperty('--collapse-button-color', 'rgb(240,240,240)');
      document.documentElement.style.setProperty('--toolbar-button-hover', 'rgba(0, 0, 0, 0.05)');
      document.documentElement.style.setProperty('--editor-placeholder-color', '#000000');
      document.documentElement.style.setProperty('--tertiary-font-color', '#efefef');
      document.documentElement.style.setProperty('--border-color', '#f0f0f0');
      document.documentElement.style.setProperty('--endpoint-bg-color', '#f5f7fa');
      document.documentElement.style.setProperty('--parameter-bg-color', '#f9f9f9');
      document.documentElement.style.setProperty('--param-border-color', '#d9d9d9');
      document.documentElement.style.setProperty('--placeholder-color', '#888');
      document.documentElement.style.setProperty('--green', 'rgb(16, 185, 129)');
      document.documentElement.style.setProperty('--orange', '#fa8c16');
      document.documentElement.style.setProperty('--red', '#f5222d');
      document.documentElement.style.setProperty('--purple', '#722ed1');
      document.documentElement.style.setProperty('--gray', '#8c8c8c');
      document.documentElement.style.setProperty('--code-bg', '#f5f5f5');
      document.documentElement.style.setProperty('--drawer-bg', '#ffff');
      document.documentElement.style.setProperty('--search-input-bg', '#E6F4FF');
    }
  }, [themeColor, mainTheme]);
  // useEffect(() => {
  //   let isdarkMode;
  //   if (mainTheme === 'light') {
  //     isdarkMode = false;
  //   }
  //   if (mainTheme === 'dark') {
  //     isdarkMode = true;
  //   }
  //   setThemeConfig(generateThemeConfig({ isdarkMode }));
  // }, [mainTheme]);

  return (
    <ThemeContext.Provider value={{ themeColor, themeConfig, changeTheme, changeBackgroundTheme, mainTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
